<template>
    <div class="wrap-card-list-post" v-bind:class="published_data && status === 1 ? 'pointer' : ''" @click="handleClick">
        <div class="card-list-post">
            <div class="card-list-img">
                <img :src="image ? image : '/assets/images/icons/image.png'" :alt="title">
            </div>
            <div class="card-list-desc">
                <div class="card-list-date">{{ moment(date) }}</div>
                <div class="card-list-title">{{ title }}</div>
                <span class="badge badge-primary" v-if="status === 6">Editing</span>
<!--                <div class="card-list-counting" v-if="type !== 'published'">-->
<!--                    <div class="card-list-post-view">-->
<!--                        <i class="icon icon-eye"></i> 1K-->
<!--                    </div>-->
<!--                    <button type="submit" class="btn btn-primary main-button pill-button bg-red" @click="edit">Edit</button>-->
<!--                </div>-->
            </div>
            <div class="btn-group dropleft" v-if="status === 2 || status === 5 || status === 7">
                <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="icon icon-more bg-white"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" @click="edit"  v-if="status === 7 || status === 2 ">Edit</a>
                    <a class="dropdown-item" @click="deleteData">Delete</a>
                </div>
            </div>

             <div class="btn-group dropleft" v-if="status === 0">
                <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="icon icon-more bg-white"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" @click="move">Pindahkan ke draft </a>
                   
                </div>
            </div>
        </div>
        <div class="alert-message" v-if="type === 'rejected' && message">
            <i class="icon icon-warn"></i>
            {{ message }}
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import 'moment/locale/id';
import axios from "axios";

export default {
    props: ['id', 'title', 'date', 'image', 'type', 'message', 'published_data', 'status'],
    methods: {
        deleteData() {
            const token = this.$cookies.get('token');
            axios.delete(`/api/article/${this.id}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.$emit('delete', true);
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    });
                })
                .catch((error) => {
                    if(error.response) {
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        })
                    }
                });
        },
        moment (date) {
            return moment(date, "YYYY-MM-DD hh:mm:ss").locale('id').format("dddd, D MMMM YYYY HH:mm");
        },
        move(){

          
            
            const token = this.$cookies.get('token');
            axios.get(`/api/article/move/${this.id}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                   
                    this.$notify({
                        duration: 5000,
                        group: 'main',
                        title: 'Berhasil!',
                        text: response.data.message,
                        type: 'success'
                    });
                    this.$router.push({path: `/post/draft`});

                })
                .catch((error) => {
                    if(error.response) {
                        this.$notify({
                            duration: 5000,
                            group: 'main',
                            title: 'Oopppss!',
                            text: error.response.data.message,
                            type: 'warn'
                        })
                    }
                });
        },
        edit() {
            this.$router.push({path: `/post/edit/${this.id}`});
        },
        handleClick() {
            if(this.published_data && this.status === 1) {
                window.open(`https://yoursay.suara.com/${this.published_data.category_path[0]}/${this.published_data.slug}`);
            }
        }
    },
}
</script>
<style scoped>
.wrap-card-list-post {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 15px;
    padding-bottom: 15px;
    position: relative;
}
.card-list-post {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-bottom: 15px;
}
.card-list-img {
    border-radius: 15px;
    width: 125px;
    height: 125px;
    background-color: #eee;
}
.card-list-img img {
    width: 125px;
    height: 125px;
    object-fit: cover;
    border-radius: 15px;
}
.card-list-desc {
    padding: 10px;
}
.card-list-date {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    color: #828282;
}
.card-list-title {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 18px;
    color: #333333;
}
.card-list-post .btn-group {
    position: absolute;
    right: 0;
    margin-top: -90px;
}
.card-list-post .btn-group .dropdown-toggle {
    content: none;
    background-color: #C4C4C4;
    border: none;
    padding: 0px 6px;
    border-radius: 6px;
}
.card-list-post .btn-group .dropdown-toggle::before {
    content: none;
}
.card-list-post .btn-group .dropdown-toggle .icon {
    width: 18px;
    height: 18px;
}
.card-list-post-view i {
    display: block;
    margin-right: 5px;
    width: 20px;
    margin-top: 0;
}
.card-list-post-view {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 11px;
    color: #828282;
}
.card-list-counting {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.card-list-counting .btn {
    width: 45px;
    height: 20px;
    font-size: 10px;
    line-height: 0;
    margin: 2px 0 0 10px;
    padding: 0;
}
.alert-message {
    display: flex;
    background-color: #E0E0E0;
    padding: 10px;
    border-radius: 10px;
    align-items: center;
}
.alert-message .icon {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    align-items: center;
}
</style>
